import React, {useEffect, useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {useAuth} from '../../hooks/useAuth';
// import {useRouter} from '../../hooks/use-router';
import {NotificationType, useNotification,} from '../../hooks/use-notification';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {Button, FormControl, Grid2, Input, Paper, Typography, Box} from '@mui/material';
import logo from '../../images/logo.png';
import InputAdornment from '@mui/material/InputAdornment';
// import { useFormState } from 'react-use-form-state';
import Email from '@mui/icons-material/Person';
import { MainContainer, MainContent } from "../DataEntry/StyledFields";

const RegistrationVerification = () => {
  // const { registerConfirm, resendSignupVerificationCode } = useAuth();
  const { confirmSignUp, resendSignUpCode, authError } = useAuth();
  // const router = useRouter();
  const navigate = useNavigate();
  const [searchParams, _setSearchParams] = useSearchParams();

  // const [formState, { email, text }] = useFormState({
  //   email: searchParams.get('email') || undefined,
  //   code: searchParams.get('code') || undefined,
  // });
  const [email, setEmail] = useState(searchParams.get('email'));
  const [code, setCode] = useState("")
  // const code = searchParams.get('code');

  const { set: setNotification } = useNotification();

  // useEffect(() => {
  //   if (email && code) {
  //     registerConfirm(email, code)
  //       .then(data => {
  //         setNotification({
  //           type: NotificationType.success,
  //           message: `Email Confirmed. You can now log in.`,
  //         });
  //         navigate('/');
  //       })
  //       .catch(err => {
  //         if (err.code === 'ExpiredCodeException') {
  //           setNotification({
  //             type: NotificationType.error,
  //             message: "Verification link expired. Please login and check the status of your verification.",
  //           });            
  //           // sendCode(
  //           //   router.query.email,
  //           //   `Verification link expired. Check email for a new code.`
  //           // );
  //         } else if (err.code === 'CodeMismatchException') {
  //           setNotification({
  //             type: NotificationType.error,
  //             message: `Verification link invalid. Check email for latest code or reset password again.`,
  //           });             
  //           // sendCode(
  //           //   router.query.email,
  //           //   `Verification link invalid. Check email for a new code.`
  //           // );
  //         } else if (err.code === 'UserNotFoundException') {
  //           setNotification({
  //             type: NotificationType.error,
  //             message: `User not found`,
  //           });
  //         } else {
  //           setNotification({
  //             type: NotificationType.error,
  //             message: err.message,
  //           });
  //         }

  //         navigate('/');
  //       });
  //   }
  //   //eslint-disable-next-line
  // }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await confirmSignUp(email, code);
    if (result) {
      setNotification({
        type: NotificationType.success,
        message: `Email Confirmed. You can now log in.`,
      });
      navigate('/');
    }
  }

  const resendConfirmationCode = async (e) => {
    e.preventDefault();
    const result = await resendSignUpCode(email);
    if (result) {
      setNotification({
        type: NotificationType.success,
        message: `A new confirmation is sent to your email. Please check your email.`,
      });      
    }
  }


  return (
    <MainContainer>
      <MainContent sx={{ width: "600px", margin: "0 auto" }}>
        <Box sx={{ my: 4, width: "100%", textAlign: "center" }}>
          <img src={logo} width="200px" alt="logo"/>
        </Box>
        <form onSubmit={handleSubmit}>

        <Grid2 container spacing={4}>          
        <Grid2 size={12}>
          <FormControl fullWidth>
            <Input
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="Email"
              startAdornment={
                <InputAdornment position="start">
                  <Email color="primary" />
                </InputAdornment>
              }
            />
            </FormControl>
        </Grid2>
        <Grid2 size={12}>
          <FormControl
              fullWidth
              style={{
                visibility: searchParams.get('code') ? 'collapse' : 'visible',
              }}
            >
              <Input
                value={code}
                onChange={e => setCode(e.target.value)}
                required
                placeholder="Verification Code"
                startAdornment={
                  <InputAdornment position="start">
                    <Email color="primary" />
                  </InputAdornment>
                }
              />
            </FormControl>

          </Grid2>
          <Grid2 size={12}>
              <Typography color="red">{authError}</Typography>
          </Grid2>
          <Grid2 size={6}>
              <Button
                fullWidth
                type="submit"
                variant="outlined"
                color="primary"
              >
                Confirm Code
              </Button>
            </Grid2>
            <Grid2 size={6}>
              <Button
                fullWidth
                type="submit"
                variant="outlined"
                color="primary"
                onClick={resendConfirmationCode}
              >
                Resend Confirmation Code
              </Button>
            </Grid2>            
          </Grid2>
        </form>
      </MainContent>
    </MainContainer>
  );
};

export default RegistrationVerification;
